import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useTrackEvent } from "../../../../components/AnalyticsProvider/useTrackEvent";
import MenuRoot from "../../../../components/Menu";
import { usePlan } from "../../../../contexts/PlanOperationContext/Plan";
import { getStore } from "../../../../util/store/store";
import { AVAILABLE_TIME_TYPE, OP_STATUS } from "../../../../util/varibles/constants";
import { IPropsChildren } from "../../../../util/varibles/interface";
import { selectPlan } from "../../constants";
import { EL_RULE } from "../../Plan/Calendar/constants";
import { planOpActions } from "../../reducer";
import { canEditOperationInPast, generateMenu, MENU_AVAILABLE_TIME, MENU_CALENDAR, MENU_OP, menuAvailableTime, menuCalendar, menuOp } from "./options";

interface IProps extends IPropsChildren {
}

const Menu: React.FC<IProps> = ({ children }) => {
    const [target] = usePlan(state => state.target);
    const dispatch = useDispatch()
    const trackEvent = useTrackEvent();

    const menu = useMemo(() => {
        let list: any[] = [];
        if (!target)
            return list;
        const { type } = target;

        switch (type) {
            case EL_RULE.VESSEL: {
                const { time, vessel } = target;
                const { isOwn, permission, available_time_type } = vessel;
                if (isOwn || permission) {
                    list.push(menuCalendar[MENU_CALENDAR.ADD_EVENT]?.({ time, vessel, dispatch }))
                    list.push(menuCalendar[MENU_CALENDAR.ADD_SERVICE]?.({ time, vessel, dispatch }))
                    if (available_time_type === AVAILABLE_TIME_TYPE.ONLY_AVAILABLE_TIME)
                        list.push(menuCalendar[MENU_CALENDAR.ADD_AVAILABLE_TIME]?.({ time, vessel, dispatch }))
                } else if (available_time_type === AVAILABLE_TIME_TYPE.ALL) {
                    list.push(menuCalendar[MENU_CALENDAR.ADD_EVENT]?.({ time, vessel, dispatch }))
                    list.push(menuCalendar[MENU_CALENDAR.ADD_SERVICE]?.({ time, vessel, dispatch }))
                }
                break;
            }
            case EL_RULE.OPERATION: {
                const { data, edit, isOwn } = target;
                const { status } = data.operation;
                const { permission: vesselPermission, isOwn: isVesselOwn } = data.vessel;

                const start = data.activity_log[0].est_start_time;
                const isActive = status !== OP_STATUS.PROCESSING
                    && status !== OP_STATUS.FINISHED
                    && (start > Date.now() || canEditOperationInPast(data));

                const op = { ...data, isActive };
                const common = { dispatch, operations: selectPlan.ops(getStore()), trackEvent }
                let opts = [];
                if (isOwn) {
                    opts = generateMenu({ ...data, isActive }, {
                        ...common, edit: () => {
                            dispatch(planOpActions.togglePopupOperation(edit()));
                        }
                    })
                } else if (vesselPermission || isVesselOwn) {
                    opts = [
                        menuOp[MENU_OP.DETAIL](op, common),
                        menuOp[MENU_OP.APPROVE](op, common),
                        menuOp[MENU_OP.DECLINE](op, common)
                    ];
                } else {
                    opts = [menuOp[MENU_OP.DETAIL](op, common)]
                }
                list = opts.filter(item => item);
                break;
            }
            case EL_RULE.AVAILABLE_TIME: {
                const { time, vessel, availableTime } = target;
                const { isOwn, permission } = vessel;
                list = (!isOwn && !permission)
                    ? [menuCalendar[MENU_CALENDAR.ADD_EVENT]?.({ time: Math.max(time, availableTime.start_time), vessel, dispatch })]
                    : [
                        menuAvailableTime[MENU_AVAILABLE_TIME.EDIT]?.({ onClick: target.edit }),
                        menuAvailableTime[MENU_AVAILABLE_TIME.DELETE]?.({ onClick: target.remove })
                    ]
                break;
            }
        }
        return list;
    }, [target, dispatch, trackEvent]);

    return <MenuRoot
        items={menu}
        visible={menu.length === 0 ? false : undefined}
        trigger={['contextMenu']}
    >
        <div className="flex relative">
            {children}
        </div>
    </MenuRoot>
}

export default Menu;
